import React from "react";
import { ToggleActionsLoaderTemplate } from "themes/common/components";

const ToggleActionsLoader = (props) => {
    return <ToggleActionsLoaderTemplate {...props} />;
};

export default ToggleActionsLoader;
